




import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import '../../assets/css/SubscriptionPlan.scss';
import SubscriptionPlan from '../../components/SubscriptionPlan.vue';
@Component({
    props: {
        memberRequest: Object,
    },
    components: {
      SubscriptionPlan,
    },
})
export default class SubscriptionPlans extends Vue {
    public mounted() {
        if (this.$props.memberRequest.memberType === 'ORG_USER') {
            if (!this.$props.memberRequest.organizationValid) {
                this.$router.push({ name: MedTransGoConstants.VIEW_ORGANIZATION_NAME });
            }
        }
    }
    private setSubscription(selectedPlan: string) {
        this.$props.memberRequest.subscriptionPlan = selectedPlan;
        this.$router.push({ name: MedTransGoConstants.VIEW_PAYMENT_INFORMATION_NAME });
    }
}
